import { Button } from '@amzn/stencil-react-components/button';
import { ExpanderContent } from '@amzn/stencil-react-components/expander';
import { TriggerButton } from '@amzn/stencil-react-components/helpers';
import { Col, Row, Spacer, View } from '@amzn/stencil-react-components/layout';
import { H5 } from '@amzn/stencil-react-components/text';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useUserInfo } from '../../../hooks/useUserInfo';
import { deleteCampaign, getAllCampaignMetrics, getCampaignMetrics } from '../../../actions/createScheduleAction';
import { getStatusIcon } from '../../../util/statusIndicatorUtil';
import ExpanderRowContent from './ExpanderRowContent';
import isEmpty from 'lodash/isEmpty';
import { Spinner, SpinnerSize } from '@amzn/stencil-react-components/spinner';
import { FormattedMessage } from 'react-intl';
import { ResponseStatus } from '../../../enums/responseStatus';

import { IconBinSmall } from '@amzn/stencil-react-icons';

const ExpanderRow = ({ name, status, metrics }) => {
  const dispatch = useDispatch();
  const userInfo = useUserInfo();
  const [isExpanded, setIsExpanded] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [metricStatus, setMetricStatus] = useState("");
  const [campaignDataWithMetrics, setCampaignDataWithMetrics] = useState([]);

  const StatusIndicator = () => {
    return getStatusIcon(status);
  };

  const onDeleteCampaign = async () => {
    setIsDeleting(true);
    await dispatch(deleteCampaign({ campaignId: metrics[0]['campaignId'] }, userInfo.idToken));
    await dispatch(getAllCampaignMetrics({ userName: userInfo.userName }, userInfo.idToken));
    setIsDeleting(false);
  };

  const onExpandingRowHandler = async () => {
    setIsExpanded(!isExpanded);
    if(!isExpanded){
      setMetricStatus(ResponseStatus.PENDING);
      const metricsData = await getCampaignMetrics({ campaignId: metrics[0]['campaignId'] }, userInfo.idToken);
      if (metricsData.status === ResponseStatus.SUCCESS) {
        setMetricStatus(metricsData.status);
        setCampaignDataWithMetrics([{
          ...metrics[0],
          uniqueDeliveries: metricsData.response.uniqueDeliveries,
          openRate: metricsData.response.openRate,
        }]);
      }
    }
  };

  const ExpanderRowWrapper = !isEmpty(metrics) ? <ExpanderRowContent metrics={campaignDataWithMetrics} /> : null;

  return (
    <Col key={name} style={{ border: '1px solid grey', padding: '10px' }}>
      <Row alignItems="center" gridGap="S200" display="flex" flexDirection="row">
        <View width="5%">
          <TriggerButton
            data-testid="trigger-btn"
            isExpanded={isExpanded}
            onClick={() => onExpandingRowHandler()}
          />
        </View>
        <View width="65%">
          <H5>{name}</H5>
        </View>
        <View width="20%">
          <StatusIndicator />
        </View>
        <View width="10%">
          <Button
            data-testid="campaign-delete-link"
            disabled={isDeleting}
            variant='tertiary'
            onClick={onDeleteCampaign}
          >
            <IconBinSmall />
            <FormattedMessage id="app.expanderRow.button.delete" defaultMessage="Delete" />
            <Spacer width="10px" />
            {isDeleting ? <Spinner size={SpinnerSize.Small} /> : null}
          </Button>
        </View>
      </Row>
      <ExpanderContent isExpanded={isExpanded}>
        <Spacer height="10px" />
        {metricStatus === ResponseStatus.PENDING ? <Spinner /> : ExpanderRowWrapper}
      </ExpanderContent>
    </Col>
  );
};

export default ExpanderRow;
